import styled from 'styled-components';

const ListContainer = styled.div`
width: 100%;
background-color: #fff;
z-index: 20;
overflow-y: scroll;
margin-top:-0.12rem;
.null-list-block {
height: 14rem;
width: 100%;
}
`;

const FoldBtn = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: .24rem;
font-family: PingFang SC;
font-weight: normal;
color: rgba(255,255,255,1);
border-radius: 43px;
width: .9rem;
height: .4rem;
background: linear-gradient(91.53deg, rgba(255,69,113,1) 0%,rgba(250,44,25,1) 100%);
`;

const NotHasMore = styled.div`
width: 100%;
text-align: center;
height: 1.3rem;
font-size: .2rem;
color: #BFBFBF;
padding-top: 0.2rem;
`;

const NoData = styled.div`
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
height: 15rem;
text-align: center;
padding-top: 2rem;
img {
width: 3rem;
height: 3rem;
}
p {
font-family: PingFangSC-Regular;
	font-size: 0.3rem;
	line-height: 0.44rem;
	color: #bfbfbf;
}
`;

const FoldMoreContainer = styled.div`
display: flex;
flex-direction: row;
align-items: center;
height: 1.08rem;
background: rgba(246,246,246,1);
z-index: 10;
margin: .2rem;
justify-content: space-between;
border-radius: .12rem;
padding-right: .2rem
`;

const FoldMoreTitleComtainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
padding: .2rem
`;

const FoldTitleText = styled.div`
color:rgba(38,38,38,1);
font-size: .26rem;
font-family: PingFang SC;
font-weight: 500;
`;


export {
  ListContainer,
  NotHasMore,
  NoData,
  FoldBtn,
  FoldMoreContainer,
  FoldMoreTitleComtainer,
  FoldTitleText
};
